// Appel final, juste avant le pied de page.
import React from "react";
import BoutonsStores from "../../site/BoutonsStores";
import Tiggy from "../../site/Tiggy";

export default function AppelFinal() {
	return (
		<section className="gs-section" style={{ paddingTop: 0 }} aria-labelledby="gs-appel-titre">
			<div className="gs-conteneur">
				<div className="gs-carte gs-appel">
					<div className="gs-quadrillage" />
					<div className="gs-appel-texte">
						<span className="gs-surtitre">Prêt ?</span>
						<h2 id="gs-appel-titre" className="gs-h2">
							Ta prochaine séance <span className="gs-accent">commence ici.</span>
						</h2>
						<p className="gs-texte">Télécharge GymNote, note ta première séance, et regarde-la progresser.</p>
						<BoutonsStores />
						<p className="gs-appel-coach">
							GymNote+ et GymNote Pro s'essaient <strong>30 jours gratuitement</strong>, depuis l'app.
						</p>
					</div>
					<Tiggy pose="victoire" taille={220} />
				</div>
			</div>
		</section>
	);
}
